import React from 'react';
import Text from '../../Atoms/Text/Text';
import Form from './Form/Form';
import { BgImage, Container, Header, Wrapper } from './Membership.style';

var Membership = function Membership(_ref) {
  var alt = _ref.alt,
      cartID = _ref.cartID,
      backgroundColor = _ref.backgroundColor,
      donateLink = _ref.donateLink,
      data = _ref.data,
      title = _ref.title,
      subtitle = _ref.subtitle,
      otherDescription = _ref.otherDescription,
      formAligntRight = _ref.formAligntRight,
      images = _ref.images,
      image = _ref.image,
      imageLow = _ref.imageLow,
      mbshipID = _ref.mbshipID;
  return React.createElement(Container, {
    formAligntRight: formAligntRight,
    backgroundColor: backgroundColor,
    id: mbshipID
  }, React.createElement(BgImage, {
    backgroundColor: backgroundColor,
    image: image,
    images: images,
    imageLow: imageLow,
    objectFit: "cover",
    width: "100%",
    height: "100%",
    alt: alt
  }), React.createElement(Wrapper, null, React.createElement(Header, null, React.createElement(Text, {
    tag: "h2",
    size: "l",
    weight: "800"
  }, title), React.createElement(Text, {
    tag: "p"
  }, subtitle)), React.createElement(Form, {
    data: data,
    otherDescription: otherDescription,
    cartID: cartID,
    mbshipID: mbshipID,
    donateLink: donateLink
  })));
};

Membership.defaultProps = {
  alt: '',
  data: {},
  formAligntRight: true,
  imageLow: null,
  image: null,
  images: null,
  backgroundColor: null,
  mbshipID: null
};
export default Membership;